module.exports = __webpack_public_path__ + "static-portal/img/18.9ea1f6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/18.jpg
// module id = ScAc
// module chunks = 4